import React from 'react'

import {useTransition} from '../../usetransition'
import {MapFeature} from '../components'
import {DEFAULT_STYLE, LOAD_ROUTE_KEY} from './consts'
import type {RouteType, Props} from './types'
import {arePropsEqual, isRoutePoints, jamsToStyle, loadRoute} from './utils'
import {genericMemo} from '../../../utils'

export const Route = genericMemo(
  <TError,>({drawJams = true, onBoundsChange, onError, points, style = DEFAULT_STYLE}: Props<TError>) => {
    const [state, startTransition] = useTransition<RouteType | null>(
      () => loadRoute(points, {onBoundsChange, onError}),
      {
        key: LOAD_ROUTE_KEY,
      },
    )
    const route = state.payload
    const isRouteAvailable = isRoutePoints(points)
    React.useEffect(() => {
      startTransition(() => loadRoute(points, {onBoundsChange, onError}))
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [points])

    if (!route || !isRouteAvailable) {
      return null
    }

    return <MapFeature {...route} style={drawJams ? jamsToStyle(route.properties.jams) : style} />
  },
  arePropsEqual,
)
